import Vue from 'vue'
import VueRouter from "vue-router"
import ShopMallAddressList from "../pages/ShopMallAddressList.vue"
import ShopMallAddAddress from "../pages/ShopMallAddAddress.vue"
import ShopMallPostSale from "../pages/ShopMallPostSale.vue"
import ShopMallPostSaleSucc from "../pages/ShopMallPostSaleSucc.vue"
Vue.use(VueRouter)
const router = new VueRouter({
    routes:[
        {
            path:'/prod/user/receiver',
            component:ShopMallAddressList,
            meta:{
                title:'我的地址'
            },
            props({query}){
                return {
                    userId:query.userId,
                    phone:query.phone
                }
            }
        },
        {
            path:'/prod/user/receiver/add',
            component:ShopMallAddAddress,
            meta:{
                title:'我的地址'
            },
            props({query}){
                return {
                    addressId:query.addressId,
                    userId:query.userId,
                    userName:query.userName,
                    userTel:query.userTel,
                    userProvince:query.userProvince,
                    userProvinceCode:query.userProvinceCode,
                    userCity:query.userCity,
                    userCityCode:query.userCityCode,
                    userDistrict:query.userDistrict,
                    userDistrictCode:query.userDistrictCode,
                    userAddress:query.userAddress,
                }
            }
        },
        {
            path:'/prod/refund',
            component:ShopMallPostSale,
            meta:{
                title:'申请售后'
            },
            props({query}){
                return {
                    orderNo:query.orderNo,
                    userId:query.userId,
                    phone:query.phone,
                    skuId:query.skuId,
                    merchandiseId:query.merchandiseId
                }
            }
        },
        {
            path:'/prod/refund/success',
            component:ShopMallPostSaleSucc,
            meta:{
                title:'申请售后'
            }
        },
        {
            path:'/',
            component:null,
            meta:{
                title:'根路由'
            }
        },
    ]
})

router.beforeEach((to, from, next) =>{
    if(to.path==='/'){
        window.location.href = "https://mall.jzjsnm.cn/h5"
    }else{
        next()
    }
    
})

router.afterEach((to, from) =>{
    document.title = to.meta.title
})

export default router